<template>
  <i icon :class="`icon-${name}`"/>
</template>
<script>
export default {
  name: 'Icon',
  props: {
    name: { type: String, default: 'white-circle' }
  }
}
</script>
<style lang="less">
@import "~@/less/proj";
[icon] { .ib; .vam;
  &.icon-white-circle { .wh(28,28); .bgc(#fff); .br(14); }
  &.icon-white-circle-arrow-right { .wh(28,28); .bgc(#fff); .br(14); }
  &.icon-arrow-circle { .wh(28,28); .bg-contain('/img/common/arrow-circle.svg'); }
  &.icon-arrow-left { .wh(28,28); .bg-contain('/img/common/arrow-left.svg'); }
  &.icon-arrow-right { .wh(24,24); .bg-contain('/img/common/arrow-right.svg'); }
  &.icon-arrow-right-white { .wh(28,28); .bg-contain('/img/common/arrow-right-white.svg'); }
  &.icon-clock { .wh(16,16); .bg-contain('/img/common/clock.svg'); }
  &.icon-more { .wh(22,22); .bg-contain('/img/common/more.svg'); }
  &.icon-launch { .wh(29,28); .bg-contain('/img/common/ico-launch.svg'); }
  &.icon-plus { .wh(16,16); .bg-contain('/img/common/ico-plus.svg'); }
}

</style>
